function addEmptyAltToImages() {
    if(!!document.querySelectorAll('img:not([alt])')) {
        document.querySelectorAll('img:not([alt])').forEach(img => {
            img.setAttribute('alt', '')
        })
    }
    
}

export default addEmptyAltToImages